import React, { useState } from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import ProductControlModal from '../controlModal/ProductControlModal';
import TierConProductPricingModal from '../TierConProductPricingModal';
import OrderDetailsModal from './OrderDetailsModal';
import { dateConverter } from '../../../../helper/Helper';


const MyPlacedConOrders = (props) => {
    // states
    const [orderModal, setOrderModal] = useState({ toggle: false, orderDetails: null });

    const subTitleStyle = {
        fontSize: '14px',
        fontWeight: 'bold',
    };
    const titleStyle = {
        fontSize: '16px',
        fontWeight: 'bold',
    };
    const emptyFieldStyle = {
        color: 'gray',
        fontStyle: 'italic',
    }

    const { companyOrdersHistory, productOrder, userData, modalStyles, modalWidth, modalTitleStyle, modalInfoTextStyle,themeColors } = props;
    if (companyOrdersHistory) {
        return (
            <React.Fragment>
                <div className="text-left p-4">
                    <h5 style={titleStyle}><b>Top up History</b></h5>
                    {productOrder ? <div className="pt-1"><TierConProductPricingModal tierId={productOrder.tierId} /></div> : <React.Fragment />}
                    <br />
                    <table className="table">
                        <thead style={{backgroundColor:'#f8f9fa'}}>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Product</th>
                                <th scope="col">Status</th>
                                <th scope="col">Order</th>
                                <th scope="col">Time</th>
                                {/* <th scope="col">Action</th> */}
                            </tr>
                        </thead>

                        <tbody>
                            {[...companyOrdersHistory].map((eachOrder, index) =>
                                <tr key={eachOrder.conOrderId}>
                                    <td scope="row">{index + 1}</td>
                                    {'itemName' in eachOrder ? <td>{eachOrder.itemName}</td> : <td style={emptyFieldStyle}>empty</td>}
                                    <td>{eachOrder.consumableMessage}</td>
                                    <td><a href="#!" onClick={() => { setOrderModal({ toggle: true, orderDetails: eachOrder }) }}>{eachOrder.conOrderId}</a></td>
                                    <td>{dateConverter(eachOrder.timestamp.seconds*1000).parsedDate}</td>
                                    {/* <td><ProductControlModal productOrder={eachOrder} /></td> */}
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* DETAILS MODAL */}
                <ReactModal
                    style={modalStyles}
                    isOpen={orderModal.toggle}
                    onRequestClose={() => { setOrderModal({ toggle: false }) }}
                    contentLabel="See order details"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { setOrderModal({ toggle: false }) }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="dynamicModalContainer">
                        <div className="dynamicModalSm">
                            <div className="px-3">
                                {orderModal.orderDetails ? <p><b>Topup on subscription:</b> {orderModal.orderDetails.appliedOn}</p> : <React.Fragment />}
                            </div>
                        </div>
                    </div>
                </ReactModal>
            </React.Fragment>
        );
    } else {
        return (
            <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        appControl: state.appControl,
        companyData: state.firestore.data.Company,
        themeColors: state.theme,
        userData: state.firebase.profile,
        userId: state.firebase.auth.uid,
        companyOrdersHistory: state.firestore.ordered.CompanyConOrdersHistory,

        productOrder: state.firestore.data.ProductOrder,
    }
}

export default compose(
    connect(mapStateToProps),
    firestoreConnect((props) => {
        const { coid } = props.companyData;
        const {isTestApp} = props.appControl;
        // console.log(isTestApp);
        return [
            {
                collection: `ConProductOrders`,
                // For testing purpose testProduct will be true.
                // In production testProduct will be false.
                where: [['coid', '==', `${coid}`],['testProduct' , '==', isTestApp]],
                orderBy: ['timestamp', 'desc'],
                storeAs: "CompanyConOrdersHistory",
            },
        ]
    })
)(MyPlacedConOrders);